import { gql } from '@apollo/client';
import { useEventContext } from './useEventContext';
import { CategoryResponse, cmsGraphql } from '@xolv-mybrightlink/common';

const FETCH_EVENT_CATEGORY = gql`
  query EventCategories {
    eventsCategories(first: 100) {
      nodes {
        databaseId
        name
        slug
      }
    }
  }
`;

export const useFetchEventCategories = async () => {
  const [state, dispatch] = useEventContext();
  if (state.initial) {
    const fetchCategories = async () => {
      const allCategoryTitle = 'All Events';
      const allCategoryItem = {
        databaseId: -1,
        name: allCategoryTitle,
        slug: allCategoryTitle.toLowerCase(),
      };
      const result = await cmsGraphql.query<CategoryResponse>({
        query: FETCH_EVENT_CATEGORY,
      });
      if (result.data.eventsCategories) {
        return [allCategoryItem, ...result.data.eventsCategories.nodes];
      }
      return [];
    };
    const categories = await fetchCategories();
    dispatch({
      type: 'category-fetched',
      categories,
    });
  }
};
